
import React from 'react';
import { SyncLog } from '../types';

interface SyncConsoleModalProps {
  isOpen: boolean;
  title?: string;
  logs: SyncLog[];
  onClose: () => void;
  isComplete: boolean;
}

export const SyncConsoleModal: React.FC<SyncConsoleModalProps> = ({ isOpen, title = "Sync Console", logs, onClose, isComplete }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[110] flex items-center justify-center p-6 bg-black/60 backdrop-blur-md"
      onClick={onClose}
    >
      <div 
        className="w-full max-w-2xl bg-gray-900 rounded-[2.5rem] border border-gray-800 shadow-2xl overflow-hidden flex flex-col h-[500px] animate-in zoom-in duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-8 py-4 border-b border-gray-800 bg-gray-900/80">
          <div className="flex gap-2">
            <div className="w-3 h-3 rounded-full bg-red-500/20 border border-red-500/50"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-500/20 border border-yellow-500/50"></div>
            <div className="w-3 h-3 rounded-full bg-green-500/20 border border-green-500/50"></div>
          </div>
          <span className="text-[10px] font-black text-gray-500 uppercase tracking-[0.2em]">{title}</span>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-white transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        
        <div className="flex-1 p-8 font-mono text-[10px] overflow-y-auto bg-[#0d1117] scrollbar-hide">
          {logs.length === 0 && (
             <div className="text-gray-600">Waiting for data stream...</div>
          )}
          {logs.map((log, idx) => (
            <div key={idx} className="mb-2 flex gap-4 animate-in slide-in-from-bottom-1 duration-200">
              <span className="text-gray-600 shrink-0 select-none">[{log.timestamp}]</span>
              <span className={
                log.type === 'success' ? 'text-green-400' : 
                log.type === 'error' ? 'text-red-400' : 
                'text-purple-400'
              }>
                {log.message}
              </span>
            </div>
          ))}
          {!isComplete && (
            <div className="flex items-center gap-2 text-purple-400/60 animate-pulse mt-2">
              <span>_</span>
              <span>Processing request...</span>
            </div>
          )}
        </div>

        <div className="px-8 py-6 bg-gray-900/50 border-t border-gray-800 flex justify-end">
          <button
            onClick={onClose}
            disabled={!isComplete}
            className={`px-8 py-2.5 rounded-full font-black text-[9px] uppercase tracking-widest transition-all ${
              isComplete 
                ? 'bg-purple-600 text-white shadow-lg shadow-purple-900/40 hover:bg-purple-500' 
                : 'bg-gray-800 text-gray-500 cursor-not-allowed opacity-50'
            }`}
          >
            {isComplete ? 'Close Console' : 'Syncing...'}
          </button>
        </div>
      </div>
    </div>
  );
};
